import { z } from 'zod';

// ─── User Event Payloads ────────────────────────────────────────────
// Zod schemas for every user-domain event.
// These represent the *command* shape published by the API (BFF).
// The users service consumes these and performs the actual DB writes.

export const UserRegisteredPayload = z.object({
    email: z.string().email(),
    displayName: z.string().min(1),
    tenantId: z.string(),
    groupIds: z.array(z.string()).optional(),
    authProviderUid: z.string().min(1).optional(),
});

export type UserRegisteredPayload = z.infer<typeof UserRegisteredPayload>;

export const UserUpdatedPayload = z.object({
    userId: z.string(),
    tenantId: z.string(),
    changes: z.record(z.string(), z.unknown()),
    previousName: z.string().optional(),
});

export type UserUpdatedPayload = z.infer<typeof UserUpdatedPayload>;

export const UserDeactivatedPayload = z.object({
    userId: z.string(),
    tenantId: z.string(),
    reason: z.string().optional(),
});

export type UserDeactivatedPayload = z.infer<typeof UserDeactivatedPayload>;

export const UserReactivatedPayload = z.object({
    userId: z.string(),
    tenantId: z.string(),
});

export type UserReactivatedPayload = z.infer<typeof UserReactivatedPayload>;

export const UserAccessGrantedPayload = z.object({
    userId: z.string(),
    accessId: z.string(),
    tenantId: z.string(),
});
export type UserAccessGrantedPayload = z.infer<typeof UserAccessGrantedPayload>;

export const UserAccessRevokedPayload = z.object({
    userId: z.string(),
    accessId: z.string(),
    tenantId: z.string(),
});
export type UserAccessRevokedPayload = z.infer<typeof UserAccessRevokedPayload>;

export const AccessEntrySchema = z.object({ accessId: z.string(), tenantId: z.string() });
export type AccessEntry = z.infer<typeof AccessEntrySchema>;

export const UserAccessReplacedPayload = z.object({
    userId: z.string(),
    oldAccessId: z.string(),
    newAccessId: z.string(),
    tenantId: z.string(),
});
export type UserAccessReplacedPayload = z.infer<typeof UserAccessReplacedPayload>;

export const UserAccessBulkGrantedPayload = z.object({
    userId: z.string(),
    grants: z.array(AccessEntrySchema).min(1),
});
export type UserAccessBulkGrantedPayload = z.infer<typeof UserAccessBulkGrantedPayload>;

export const UserAccessBulkRevokedPayload = z.object({
    userId: z.string(),
    revocations: z.array(AccessEntrySchema).min(1),
});
export type UserAccessBulkRevokedPayload = z.infer<typeof UserAccessBulkRevokedPayload>;
